define.alias("ember-power-select/components/power-select/before-options", "calendar/components/power-select/before-options");